export default __webpack_public_path__ + "static/Hes-so_logo-808f5a79c90db48ab121688dadbafbad.svg";